export enum ActivityTypologyStyle {
  CHALLENGE = 'reto',
  MANIPULATIVE = 'manipulativa',
  MENTAL_MAP = 'mapa_mental',
  AUTOEVALUATION = 'autoevaluacion',
  TEST = 'prueba',
  MENTAL_CALCULATION = 'calculo_mental',
  VIDEO_ACTIVITY = 'video_actividad',
  INVESTIGATION = 'investigacion',
  DEMONSTRATION_PLAY = 'juego_demostracion',
  TEST_YOURSELF = 'ponte_a_prueba',
  PORFOLIO = 'porfolio',
  DIVERSITY_ATTENTION = 'atencion_diversidad',
  MASTER_CLASS = 'master_class',
  THOUGHT_ROUTINE = 'rutina_pensamiento',
  THINKING_STRATEGY = 'estrategia_pensamiento',
  OXYGEN = 'oxigeno',
  EXERCISE = 'ejercicio',
  THEORETICAL_RESOURCE = 'recurso_teorico',
  PPL = 'ppl'
}

export type ActivityTypologyStyleType = `${ActivityTypologyStyle}`;
